import React from 'react';
import { isOfType } from '../../ts-utils';
import { highlightNavigationPromptTarget } from '../components/comment-list/use-highlight-comment';
import { useConfiguration } from '../context/configuration-context/use-configuration';
let promptHandlers = [];
export const enableNavigationPrompt = (cb) => {
    promptHandlers.push(cb);
    return () => {
        promptHandlers = promptHandlers.filter((x) => x !== cb);
    };
};
export const useNavigationPrompt = ({ resolveCancelFlow, formIsMounted, }) => {
    const { disableNavigationPrompt } = useConfiguration();
    React.useEffect(() => {
        if (formIsMounted && !disableNavigationPrompt) {
            return enableNavigationPrompt(resolveCancelFlow);
        }
    }, [formIsMounted, resolveCancelFlow, disableNavigationPrompt]);
};
export const useInitNavigationPrompt = ({ isMobile }) => {
    // Don't allow our redirect to retriger cancels
    let internalNavigate = false;
    const handleDocumentClick = (event) => {
        if (internalNavigate) {
            return;
        }
        let element = event.target;
        while (element?.tagName.toLowerCase() !== 'a') {
            element = element.parentElement;
            if (!element) {
                return;
            }
        }
        if (element.getAttribute('target') === '_blank') {
            return;
        }
        const pauseNavigation = () => {
            event.preventDefault();
            event.stopImmediatePropagation();
        };
        const resumeNavigation = () => {
            internalNavigate = true;
            event.target.click();
        };
        const cancelationResults = promptHandlers.map((handler) => handler());
        cancelationResults.filter(isOfType('SILENT_CANCEL')).forEach((r) => r.cleanup());
        const cancelationsWithPrompts = cancelationResults.filter(isOfType('PROMPT'));
        if (cancelationsWithPrompts.length === 0) {
            return;
        }
        pauseNavigation();
        const first = cancelationsWithPrompts[0];
        if (first.highlightId) {
            highlightNavigationPromptTarget(first.highlightId, isMobile);
        }
        first.prompt().then((promptResult) => {
            if (promptResult === 'CANCEL_DISCARD') {
                return;
            }
            else {
                cancelationsWithPrompts.forEach((p) => p.onConfirm());
                resumeNavigation();
            }
        });
    };
    const handleUnload = (event) => {
        const cancelationResults = promptHandlers.map((handler) => handler());
        const cancelationsWithPrompts = cancelationResults.filter(isOfType('PROMPT'));
        if (cancelationsWithPrompts.length === 0) {
            return;
        }
        // Cancel the event
        event.preventDefault();
        // Chrome requires returnValue to be set
        event.returnValue = '';
        const first = cancelationsWithPrompts[0];
        if (first.highlightId) {
            highlightNavigationPromptTarget(first.highlightId, isMobile);
        }
    };
    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            window.document.addEventListener('click', handleDocumentClick, true);
            window.addEventListener('beforeunload', handleUnload);
        }
        return () => {
            if (typeof window !== 'undefined') {
                window.document.removeEventListener('click', handleDocumentClick, true);
                window.removeEventListener('beforeunload', handleUnload);
            }
        };
    }, [isMobile]);
};
//# sourceMappingURL=use-navigation-prompt.js.map